// extracted by mini-css-extract-plugin
module.exports = {"iconWrapper":"style_iconWrapper__YGuWM"};